import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';
import { BpgCommonService } from 'src/app/bpg-common/services/bpg-common.service';
import { LandingPaginationDTO } from 'src/app/bpg-common/services/data.services';
import { BpgMembershipService } from 'src/app/bpg-membership/bpg-membership.service';

@Component({
  selector: 'app-membership-group-sign-up',
  templateUrl: './membership-group-sign-up.component.html',
  styleUrls: ['./membership-group-sign-up.component.css']
})
export class MembershipGroupSignUpComponent implements OnInit, AfterViewInit {

  showNewSignUp = true;
  showPastEnrollments = false;
  showBpgSettings = false;
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  loginData: any = JSON.parse(localStorage.getItem("loginData"));
  userId: any = this.loginData["userId"];
  workdayId: any;
  badgeId: any;
  memberFirstName: any;
  memberLastName: any;
  memberMiddleName: any;
  memberWorkdayId: any;
  memberBadgeId: any;
  memberEmailId: any;
  siteLocation: any = this.loginData['site']['siteName'];
  showTeamMemberDetials: boolean;
  userDetails: any = [];
  bpgList: any = [];
  userNotFound: boolean;
  siteId: any = this.loginData['site']['siteId'];
  memberUserId: any;
  isEmailInvalid: boolean;
  isEmailNotMatching: boolean;
  emailAddress: any;
  recheckEmailAddress: any;
  membershipsUpdated: boolean;
  settingsUpdated: boolean;
  landingDto: any;
  LandingPaginationDTO: LandingPaginationDTO = new LandingPaginationDTO();
  currentNumberOfElements: number = ConstantValues.pageLimit;
  limit: number = ConstantValues.pageLimit;
  currentShowingElements: number = ConstantValues.pageLimit;
  pastEnrollments: any;
  tableShow: boolean;
  noDataFound: boolean;
  numberOfElements: any;
  currentPage = 0;
  totalPages = 0;
  deleteSuccess: boolean;
  showAll: boolean;
  showByToday: boolean;
  showByMonth: boolean;
  showByYear: boolean;
  enrollmentList: any = [];
  disableSubmitButton = true;
  method: string;
  msg: string;
  param: any;
  adminId: string = localStorage.getItem("adminId");
  searchText: string;
  membersiteName: any;
  @ViewChild('input', { static: false }) input!: ElementRef<HTMLInputElement>;
  disableSaveButton: boolean;
  disableResetButton: boolean;
  filterType: string;
  settingsReset: boolean;
  constructor(private readonly membershipService: BpgMembershipService,
    private readonly router: Router,
    private readonly bpgCommonService: BpgCommonService,
    private readonly spinner: Ng4LoadingSpinnerService) { }
  ngAfterViewInit(): void {
    this.input.nativeElement.focus();
  }

  ngOnInit() {
    if (
      localStorage.getItem("loginData") === null ||
      localStorage.getItem("loginData") === undefined
    ) {
      this.router.navigate(["/log-out"]);
    }


    if (localStorage.getItem("logOutFlag") === "true") {
      this.router.navigate(["/log-out"]);
    }

    if (!(this.adminId === '1' || this.adminId === '2' || this.adminId === '3' || localStorage.getItem("isbpgAdmin") === "true" || localStorage.getItem("isbpgLeadAdmin") === "true")) {
      this.router.navigate(["/log-out"]);
    }
    this.logUserAction();
  }
  fetchUserDetails(type, event) {
    this.badgeId = null;
    this.workdayId = null;
    if (type === "badge") {
      this.badgeId = event.target.value;
    }
    if (type === "workday") {
      this.workdayId = event.target.value;
    }
    if (event.target.value.trim().length === 6) {
      let trimedWorkdayId = this.workdayId;
      let trimedBadgeId = this.badgeId;
      if (type === "badge") {
        trimedBadgeId = trimedBadgeId.replace(/^0+/, '');
      } else {
        trimedWorkdayId = trimedWorkdayId.replace(/^0+/, '');
      }

      this.spinner.show();
      const userData = {
        "userId": this.userId,
        "workdayId": trimedWorkdayId,
        "badgeId": trimedBadgeId
      };
      this.membershipService.fetchUserDetialsForMembershipGroupSignUp(userData).subscribe(res => {
        this.spinner.hide();
        if (res != null && res !== undefined) {
          this.userDetails = [];
          if (res.userDetails != null) {
            this.userDetails.push(res.userDetails);
            this.memberFirstName = this.userDetails[0].userFirstName;
            this.memberLastName = this.userDetails[0].userLastName;
            this.memberWorkdayId = this.userDetails[0].workdayId;
            this.memberBadgeId = this.userDetails[0].badgeId;
            this.memberEmailId = this.userDetails[0].emailId;
            this.memberUserId = this.userDetails[0].userId;
            this.membersiteName = this.userDetails[0].site.siteName;
            this.showTeamMemberDetials = true;
            this.userNotFound = false;
          } else {
            this.memberFirstName = null;
            this.memberLastName = null;
            this.memberWorkdayId = null;
            this.memberUserId = null;
            this.memberBadgeId = null;
            this.memberEmailId = null;
            this.userNotFound = true;
            this.membersiteName = null;
            this.showTeamMemberDetials = false;
          }
          if (res.bpgsList != null) {
            this.bpgList = res.bpgsList;
            if (this.bpgList != null && this.bpgList.length > 0) {
              this.bpgList.forEach((bpg) => {
                bpg.siteId = this.siteId;
                bpg.checked = false;
                bpg.isSaved = false;
                bpg.userSpecific = false;
                bpg.isUserAlreadyMember = false;
                if (
                  bpg.bpgName != null &&
                  bpg.bpgName !== "" &&
                  bpg.bpgName !== undefined
                ) {
                  bpg.wordCount = bpg.bpgName.trim().length;
                  if (bpg.wordCount >= 53) {
                    bpg.minWord = bpg.bpgName.slice(0, 50);
                    bpg.minWord = bpg.minWord + "...";
                    bpg.showFullWord = false;
                  } else{ bpg.showFullWord = true;}
                } else {
                  bpg.showFullWord = true;
                }
              });
            }
            if (res.adminConfiguredBpgs != null) {
              const adminConfiguredBps = res.adminConfiguredBpgs;
              adminConfiguredBps.forEach((res) => {
                this.bpgList.forEach((bpg) => {
                  if (res.bpgId === bpg.bpgId && res.bpgName === bpg.bpgName) {
                    bpg.isSaved = true;
                    bpg.userSpecific = true;
                    res.showFullWord = bpg.showFullWord;
                  }
                });
              });
            }
            if (res.registeredBpgs != null) {
              const registeredBpgs = res.registeredBpgs;
              registeredBpgs.forEach((res) => {
                this.bpgList.forEach((bpg) => {
                  if (res.bpgId === bpg.bpgId && res.bpgName === bpg.bpgName) {
                    bpg.isUserAlreadyMember = true;
                    bpg.userSpecific = false;
                  }
                });
              });
            }
            this.emailAddress = null;
            this.recheckEmailAddress = null;
            this.isEmailInvalid = false;
            this.isEmailNotMatching = false;
            // to enable/disable submit button
            this.submitButtonEnableCheck();
          }

        }
      },
        (err) => {
          this.spinner.hide();
          if (err.value.statusText === ConstantValues.unknownError) {
            this.timeOutError = true;
          }
        });
    }
  }
  submitButtonEnableCheck() {
    this.disableSubmitButton = true;
    this.bpgList.forEach((bpg) => {
      if (!bpg.isUserAlreadyMember && (bpg.userSpecific)) {
        this.disableSubmitButton = false;
      }
    });
  }
  getNewSignUpDetails() {
    this.showNewSignUp = true;
    this.showPastEnrollments = false;
    this.searchText = null;
    this.filterType = null;
    this.timeOutError = false;
  }

  getPastEnrollmentDetails() {
    this.showNewSignUp = false;
    this.showPastEnrollments = true;
    this.showBpgSettings = false;
    this.timeOutError = false;
    this.listPastEnrollments();
  }

  listPastEnrollments() {
    this.spinner.show();
    this.membershipService.fetchPastEnrollmentsData(this.userId).subscribe(res => {
      if (res != null && res !== undefined) {
        this.spinner.hide();
        this.pastEnrollments = res;
        if (this.pastEnrollments.length === 0) {
          this.tableShow = false;
          this.noDataFound = true;
        }
        else {
          this.enrollmentList = [];
          this.tableShow = true;
          this.noDataFound = false;
          this.showAll = true;
          this.showByMonth = false;
          this.showByToday = false;
          this.showByYear = false;
          this.pastEnrollments.forEach((enrollment) => {
            const wordCount = enrollment.bpgName.trim().length;
            if (wordCount >= 40) {
              enrollment.bpgName = enrollment.bpgName.slice(0, 37) + "...";
            }
          });
          this.enrollmentList = [...this.pastEnrollments];
        }
        this.numberOfElements = res.length;
        if (this.filterType != null && this.filterType !== '') {
          this.filterBy(this.filterType,false);
        }
        if (this.searchText != null && this.searchText !== '') {
          this.filterTableDate(this.searchText);
        }


      }
    },
      err => {
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      });
  }
  pageChanged(event) {
    this.LandingPaginationDTO.page = event - 1;
    this.currentPage = event;
    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
  }
  viewBPGSettings() {
    this.showBpgSettings = true;
    this.bpgList.forEach(bpg => {
      if (bpg.isSaved) {
        bpg.checked = true;
      }
    });
    // enable/disble save button
    this.disableSaveButton = true;
    this.disableResetButton = true;
    this.bpgList.forEach(res => {
      if (res.checked) {
        this.disableSaveButton = false;
        this.disableResetButton = false;
      }
    });

  }
  delete(data) {
    this.method = "confirmDelete";
    this.param = data;
    this.msg = "Are you sure you want to remove the membership ?";
  }
  confirmDelete(data: any) {
    this.membershipService.deleteEnrollment(data.mappingId).subscribe(_res => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      this.deleteSuccess = true;
      setTimeout(function () {
        this.deleteSuccess = false;
        this.showTeamMemberDetials = false;
        this.showBpgSettings = false;
        this.showPastEnrollments = true;
        this.badgeId = null;
        this.workdayId = null;
        this.emailAddress = null;
        this.recheckEmailAddress = null;
        this.isEmailInvalid = false;
        this.isEmailNotMatching = false;
      }.bind(this), 2000);
      this.getPastEnrollmentDetails();
    },
      err => {
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      });
  }
  toggleCheckbox(event, data) {
    const bpg = JSON.parse(JSON.stringify(data));
    if (event.target.checked) {
      this.bpgList.forEach(res => {
        if (res.bpgId === bpg.bpgId) {
          res.checked = true;
        }
      });
    } else {
      this.bpgList.forEach(res => {
        if (res.bpgId === bpg.bpgId) {
          res.checked = false;
        }
      });
    }
    // enable/disble save button
    this.disableSaveButton = true;
    this.bpgList.forEach(res => {
      if (res.checked) {
        this.disableSaveButton = false;
      }
    });

  }

  toggleCheckboxForUser(event, data) {
    const bpg = JSON.parse(JSON.stringify(data));
    if (event.target.checked) {
      this.bpgList.forEach(res => {
        if (res.bpgId === bpg.bpgId) {
          res.userSpecific = true;
        }
      });
    } else {
      this.bpgList.forEach(res => {
        if (res.bpgId === bpg.bpgId) {
          res.userSpecific = false;
        }
      });
    }
    // to enable/disable submit button
    this.submitButtonEnableCheck();
  }
  cancel() { 
    this.showBpgSettings = false;
    this.showNewSignUp = true;
    this.timeOutError = false;
  }
  reset() {
    this.method = "confirmReset";
    this.msg = "Are you sure you want to delete all the preferences ?";
  }
  confirmReset() {
    this.bpgList.forEach(bpg => {
      bpg.checked = false;
      bpg.isSaved = false;
    });

    // to enable/disable submit button
    this.disableSaveButton = true;
    this.confirmSave('reset');
    this.submitButtonEnableCheck();
  }
  filterBy(type, clearSearchText: boolean) {
    if (clearSearchText) {
      this.searchText = null;
    }
    this.filterType = type;
    const currentDate = new Date();
    let fiscalYear;
    if (currentDate.getMonth() < 3) {
      fiscalYear = currentDate.getFullYear();
    }
    else if (currentDate.getMonth() >= 3) {
      fiscalYear = currentDate.getFullYear() + 1;
    }
    this.enrollmentList = [];
    if (type === 'All') {
      this.showAll = true;
      this.showByMonth = false;
      this.showByToday = false;
      this.showByYear = false;
      this.enrollmentList = [...this.pastEnrollments];
    } else if (type === 'Today') {
      this.showByToday = true;
      this.showAll = false;
      this.showByMonth = false;
      this.showByYear = false;
      this.pastEnrollments.forEach((enrollment) => {
        const dateString: string = enrollment.date; // MM-DD-YYYY format
        const [month, day, year] = dateString.split('-');
        const dateObject: Date = new Date(+year, +month - 1, +day);
        if (dateObject.getDay() === currentDate.getDay() && dateObject.getMonth() + 1 === currentDate.getMonth() + 1 && dateObject.getFullYear() === currentDate.getFullYear()) {
          this.enrollmentList.push(enrollment);
        }
      });
    } else if (type === 'Month') {
      this.showByMonth = true;
      this.showByToday = false;
      this.showAll = false;
      this.showByYear = false;
      this.pastEnrollments.forEach((enrollment) => {
        const dateString: string = enrollment.date; // MM-DD-YYYY format
        const [month, day, year] = dateString.split('-');
        const dateObject: Date = new Date(+year, +month - 1, +day);
        if (dateObject.getMonth() + 1 === currentDate.getMonth() + 1 && dateObject.getFullYear() === currentDate.getFullYear()) {
          this.enrollmentList.push(enrollment);
        }
      });
    } else if (type === 'FiscalYear') {
      this.showByYear = true;
      this.showByMonth = false;
      this.showByToday = false;
      this.showAll = false;
      this.pastEnrollments.forEach((enrollment) => {
        const dateString: string = enrollment.date; // MM-DD-YYYY format
        const [month, day, year] = dateString.split('-');
        const dateObject: Date = new Date(+year, +month - 1, +day);
        let dataFiscalYear;
        if (dateObject.getMonth() < 3) {
          dataFiscalYear = dateObject.getFullYear();
        }
        else if (dateObject.getMonth() >= 3) {
          dataFiscalYear = dateObject.getFullYear() + 1;
        }
        if (dataFiscalYear === fiscalYear) {
          this.enrollmentList.push(enrollment);
        }
      });
    }
    if (this.enrollmentList.length === 0) {
      this.tableShow = false;
      this.noDataFound = true;
    } else {
      this.tableShow = true;
      this.noDataFound = false;
    }
    this.numberOfElements = this.enrollmentList.length;
  }
  onKey(name) {
    if (this.showAll) {
      this.filterBy('All',false);
    } else if (this.showByToday) {
      this.filterBy('Today',false);
    } else if (this.showByMonth) {
      this.filterBy('Month',false);
    } else if (this.showByYear) {
      this.filterBy('FiscalYear',false);
    } 
    this.filterTableDate(name.value);
  }
  filterTableDate(text) {
    if (text !== '') {
      const filterBySearch = [];
      this.enrollmentList.forEach((enrollment) => {
        if (enrollment.name.toLowerCase().includes(text.toLowerCase())) {
          filterBySearch.push(enrollment);
        }
      });
      this.enrollmentList = filterBySearch;
      if (this.enrollmentList.length === 0) {
        this.tableShow = false;
        this.noDataFound = true;
      } else {
        this.tableShow = true;
        this.noDataFound = false;
      }
      this.numberOfElements = this.enrollmentList.length;
    }
  }
  save() {
    this.method = "confirmSave";
    this.msg = "Are you sure you want to save preference(s) ?";
  }
  confirmSave(type?: string) {
    this.spinner.show();
    let bpgIds = "";
    for (const bpgs of this.bpgList) {
      if (bpgs.checked) {
        if (bpgIds === "") {
          bpgIds = bpgs.bpgId;
        }
        else {
          bpgIds = `${bpgIds},${bpgs.bpgId}`;
        }
      }
    }
    const bpgSettingsData = {
      "userId": this.userId,
      "siteId": this.siteId,
      "bpgIds": bpgIds
    };
    this.membershipService.saveBpgSettingsForAdmin(bpgSettingsData).subscribe(res => {
      this.spinner.hide();
      if (res != null && res !== undefined) {
        if (type === 'reset') {
          this.settingsReset = true;
        } else {
          this.settingsUpdated = true;
        }
        this.disableResetButton = true;
        this.bpgList.forEach(bpg => {
          if (bpg.checked) {
            bpg.isSaved = true;
            bpg.userSpecific = true;
            this.disableResetButton = false;
          } else {
            bpg.isSaved = false;
            bpg.userSpecific = false;
          }
        });
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        setTimeout(() => {
          if (type === 'reset') {
            this.settingsReset = false;
          } else {
            this.settingsUpdated = false;
            this.showBpgSettings = false;
            this.showNewSignUp = true;
          }
          // to enable/disable submit button
          this.submitButtonEnableCheck();
        }, 2000);
      }
    },
      (err) => {
        this.spinner.hide();
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      });

  }

  checkEmailType(event) {
    if (event.target.value !== "") {
      const re = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/);
      if (re.test(String(event.target.value).toLowerCase()) === false) {
        this.isEmailInvalid = true;
      }
      else {
        this.isEmailInvalid = false;
      }
    }
    else {
      this.isEmailInvalid = false;
    }
  }

  RecheckEmailType(event) {
    if (event.target.value !== "") {
      if (event.target.value.toLowerCase() === this.emailAddress.toLowerCase()) {
        this.isEmailNotMatching = false;
      } else {
        this.isEmailNotMatching = true;
      }
    }
    else {
      this.isEmailNotMatching = false;
    }
  }
  saveGroupMembership() {
    this.method = "confirmSaveGroupMembership";
    this.msg = "Are you sure you want to submit the membership(s) ?";
  }
  confirmSaveGroupMembership() {
    this.spinner.show();
    const userMembershipList = [];
    this.bpgList.forEach(bpg => {
      if (bpg.userSpecific) {
        userMembershipList.push({
          "bpgId": bpg.bpgId,
          "bpgName": bpg.bpgName,
          "siteId": bpg.siteId,
          "siteName": this.siteLocation
        });
      }
    });
    let emailId = null;
    if (emailId === null && this.emailAddress!=null && this.recheckEmailAddress!=null && !this.isEmailNotMatching && !this.isEmailInvalid && this.emailAddress.toLowerCase()===this.recheckEmailAddress.toLowerCase()) {
      emailId = this.emailAddress.toLowerCase();
    }
    const membershipData = {
      "userId": this.memberUserId,
      "emailId": emailId,
      "membershipList": userMembershipList,
      "adminUserId": this.userId
    };
    this.membershipService.saveUserDetialsForMembershipGroupSignUp(membershipData).subscribe(res => {
      this.spinner.hide();
      if (res != null && res !== undefined) {
        this.membershipsUpdated = true;
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.membershipsUpdated = false;
          this.showTeamMemberDetials = false;
          this.showBpgSettings = false;
          this.showPastEnrollments = false;
          this.badgeId = null;
          this.workdayId = null;
          this.emailAddress = null;
          this.recheckEmailAddress = null;
          this.isEmailInvalid = false;
          this.isEmailNotMatching = false;
          this.input.nativeElement.focus();
        }, 2000);
      }
    },
      (err) => {
        this.spinner.hide();
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      });
  }

  logUserAction() {
    const data = {
      userId : this.userId,
      categoryDescription : "Membership Group SignUp Screen"
    };
    this.bpgCommonService.logUserAction(data).subscribe(
      (_data) => {});
  }
}
